import { render, staticRenderFns } from "./create-task-modal.vue?vue&type=template&id=4f5d3496&scoped=true"
import script from "./create-task-modal.vue?vue&type=script&lang=js"
export * from "./create-task-modal.vue?vue&type=script&lang=js"
import style0 from "./create-task-modal.vue?vue&type=style&index=0&id=4f5d3496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d3496",
  null
  
)

export default component.exports